import SignalCellularAlt from "@mui/icons-material/SignalCellularAlt";
import SignalCellularAlt1Bar from "@mui/icons-material/SignalCellularAlt1Bar";
import SignalCellularAlt2Bar from "@mui/icons-material/SignalCellularAlt2Bar";
import { Box, Tooltip } from "@mui/material";
import { alpha, type Theme } from "@mui/material/styles";

import { getNotificationPriorityLabel } from "./notificationPresentation";

type NotificationPriorityIndicatorSize = "small" | "medium";

function PriorityGlyph({
  priority,
  iconSize,
  emphasized,
}: {
  priority: string;
  iconSize: number;
  emphasized: boolean;
}) {
  const sx = (theme: Theme) => ({
    color: emphasized ? theme.palette.text.primary : theme.palette.text.secondary,
    fontSize: iconSize,
  });

  if (priority === "LOW") {
    return <SignalCellularAlt1Bar sx={sx} />;
  }

  if (priority === "HIGH") {
    return <SignalCellularAlt sx={sx} />;
  }

  return <SignalCellularAlt2Bar sx={sx} />;
}

export function NotificationPriorityIndicator({
  priority,
  size = "small",
  emphasized = false,
}: {
  priority: string;
  size?: NotificationPriorityIndicatorSize;
  emphasized?: boolean;
}) {
  const label = getNotificationPriorityLabel(priority);
  const dimension = size === "medium" ? 28 : 22;
  const iconSize = size === "medium" ? 22 : 18;

  return (
    <Tooltip title={label}>
      <Box
        component="span"
        role="img"
        aria-label={label}
        sx={(theme) => ({
          alignItems: "center",
          borderRadius: 1,
          display: "inline-flex",
          height: dimension,
          justifyContent: "center",
          verticalAlign: "middle",
          width: dimension,
          "&:hover": {
            bgcolor: alpha(theme.palette.text.secondary, 0.08),
          },
        })}
      >
        <PriorityGlyph priority={priority} iconSize={iconSize} emphasized={emphasized} />
      </Box>
    </Tooltip>
  );
}
